"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateUserInCache;

var _getOrganisationInvite = _interopRequireDefault(require("../queries/getOrganisationInvite"));

var _defaultUser = _interopRequireDefault(require("../constants/defaultUser"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function updateUserInCache(_ref) {
  var changes = _ref.changes;
  return function (apolloClient, _ref2) {
    var data = _ref2.data,
        errors = _ref2.errors;

    if (!data || errors && errors.length) {
      return;
    }

    var createUser = data.createUser,
        updateUser = data.updateUser;

    var _apolloClient$readQue = apolloClient.readQuery({
      query: _getOrganisationInvite.default
    }),
        _apolloClient$readQue2 = _apolloClient$readQue.getOrganisationInvite,
        organisation = _apolloClient$readQue2.organisation,
        user = _apolloClient$readQue2.user;

    apolloClient.writeQuery({
      query: _getOrganisationInvite.default,
      data: {
        getOrganisationInvite: {
          organisation: organisation,
          user: _objectSpread({}, _defaultUser.default, {
            userId: (createUser || updateUser || {}).userId
          }, user, {}, changes, {
            __typename: 'User'
          }),
          __typename: 'OrganisationInvite'
        }
      }
    });
  };
}